export function getScenarioNamePrompt(scenarioSubData: any): string {
  return `
    Craft a compelling and succinct title (max 5 words) for this scenario:

    <SCENARIO_DATA>
    ${JSON.stringify(scenarioSubData, null, 2)}
    </SCENARIO_DATA>

    Your task:
    1. Analyze the provided scenario data
    2. Identify the key elements and themes
    3. Create a catchy, descriptive title that encapsulates the scenario's essence
    4. Ensure the title is no longer than 5 words

    Deliver a punchy, memorable title that instantly communicates the core of this scenario.
  `;
}
